import cx from 'clsx';

import { TProps } from './types/TProps';

export const AppVersionTag = ({ version, className }: TProps) => (
  <span
    className={cx(
      'pointer-events-none fixed bottom-1 right-1 z-[100] select-none text-[10px] font-medium leading-none text-[var(--color-text-subtle)]',
      className,
    )}
  >
    {version}
  </span>
);
